const eyeOpen =
  'M6.27609 36.4595C4.97334 35.0498 3.9448 33.8621 3.22114 33C3.9448 32.1379 4.97334 30.9502 6.27609 29.5405C9.07439 26.5125 13.1228 22.4764 18.1184 18.4456C28.1762 10.33 41.7458 2.5 56.5 2.5C71.2542 2.5 84.8238 10.33 94.8816 18.4456C99.8772 22.4764 103.926 26.5125 106.724 29.5405C108.027 30.9502 109.055 32.1379 109.779 33C109.055 33.8621 108.027 35.0498 106.724 36.4595C103.926 39.4875 99.8772 43.5236 94.8816 47.5544C84.8238 55.67 71.2542 63.5 56.5 63.5C41.7458 63.5 28.1762 55.67 18.1184 47.5544C13.1228 43.5236 9.07439 39.4875 6.27609 36.4595Z';
const eyeShut =
  'M7.27609 36.4595C5.97334 35.0498 4.9448 33.8621 4.22114 33C4.9448 32.1379 5.97334 30.9502 7.27609 29.5405C10.0744 26.5125 14.1228 22.4764 19.1184 18.4456C29.1762 10.33 42.7458 2.5 57.5 2.5C72.2542 2.5 85.8238 10.33 95.8816 18.4456C100.877 22.4764 104.926 26.5125 107.724 29.5405C109.027 30.9502 110.055 32.1379 110.779 33C110.055 33.8621 109.027 35.0498 107.724 36.4595C104.926 39.4875 100.877 43.5236 95.8816 47.5544C85.8238 55.67 72.2542 63.5 57.5 63.5C42.7458 63.5 29.1762 55.67 19.1184 47.5544C14.1228 43.5236 10.0744 39.4875 7.27609 36.4595Z';

const togglePasswordVisibility = (
  [passVis, setPassVis],
  [svgPath, setSVGPath],
  [svgCX, setSVGcx],
  [lineWidth, setLineWidth]
) => {
  setPassVis(passVis === 'password' ? '' : 'password');
  setSVGPath(svgPath === eyeOpen ? eyeShut : eyeOpen);
  setSVGcx(svgCX === '56.5' ? '57.5' : '56.5');
  setLineWidth(lineWidth === '0' ? '5' : '0');
};

export { eyeOpen, togglePasswordVisibility };
